import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Skeleton — loading placeholder.
 *
 * Use for shell rendering while TanStack Query is fetching. Prefer over
 * spinner-only loading states for layout-stable UIs (tables, card lists,
 * detail panels).
 *
 * Example:
 *   {isLoading
 *     ? <Skeleton className="h-8 w-48" />
 *     : <h2>{building.name}</h2>}
 */
const Skeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn("animate-pulse rounded-md bg-muted", className)}
    {...props}
  />
);

export { Skeleton };
